import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { S_Phone, D_EuroSign, D_SignHanging, D_Handshake } from 'hosman-material';

import RADAR_LEADS from '../../../../../../../../../api/ressources/App/radarLeads';
import { updatePhoneNumberModalOpen, updateRadarLeadsCount } from '../../../../../../../../../reducers/_Pages/Public/radarSlice';

const PriceDisplay = ({ property, setProperty }) => {
  const { radarLeadsCount } = useSelector((state) => state.radar);
  const dispatch = useDispatch();

  const fetchPrices = async () => {
    if (property.sale_price) return;
    if (radarLeadsCount >= 3) return dispatch(updatePhoneNumberModalOpen(true));

    try {
      const response = await RADAR_LEADS.createRadarLead({ property_id: property.id })

      setProperty({...property, sale_price: response.data.sale_price, oa_amount: response.data.oa_amount});
      dispatch(updateRadarLeadsCount(response.data.radar_leads_count));
    } catch (error) {
      if (error.response && error.response.status === 422) {
        dispatch(updatePhoneNumberModalOpen(true));
      }
    }
  }

  const priceContent = () => {
    if (!property.sale_price) {
      if (radarLeadsCount > 3) {
        return (
          <div className='flex items-start gap-2 text-ih-green font-bold mt-3'>
            <div><FontAwesomeIcon icon={S_Phone} /></div>
            <p>Un expert va vous contacter prochainement pour vous donner les prix des biens qui vous intéressent.</p>
          </div>
        )
      } else {
        return (
          <div className={`flex items-start gap-2 ${property.sale_price ? '' : 'p-3 w-max border rounded-xl cursor-pointer hover:bg-white/20'}`} onClick={fetchPrices}>
            <div className='w-4'><FontAwesomeIcon icon={D_EuroSign} /></div>
            <p>Voir le prix de vente réel</p>
          </div>
        )
      }
    } else {
      return (
        <div className='flex flex-col gap-3'>
          <div className='flex items-center gap-2'>
            <div className='w-4'><FontAwesomeIcon icon={D_EuroSign} /></div>
            <p>Prix de vente réel : <span className='text-ih-blue font-bold'>{property.oa_amount?.toLocaleString()}€ ({Math.round(property.oa_amount/property.area)?.toLocaleString()}€/m²)</span></p>
          </div>
          <div className='flex items-center gap-2'>
            <div className='w-4'><FontAwesomeIcon icon={D_SignHanging} /></div>
            <p>Prix affiché : <span className='text-ih-blue font-bold'>{property.sale_price?.toLocaleString()}€</span></p>
          </div>
          <div className='flex items-center gap-2'>
            <div className='w-4'><FontAwesomeIcon icon={D_Handshake} /></div>
            <p>Négociation : <span className='text-ih-blue font-bold'>{Math.max(0, Math.round(((property.sale_price - property.oa_amount) / property.sale_price * 100) * 10) / 10)}%</span></p>
          </div>
        </div>
      )
    }
  }

  return priceContent();
};

export default PriceDisplay;
